module.exports = __webpack_public_path__ + "img/tu_file_xlsx.8493c323.svg";